var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTakingPicturesCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 28C1.75 34.9619 4.51562 41.6387 9.43845 46.5616C14.3613 51.4844 21.0381 54.25 28 54.25C34.9619 54.25 41.6387 51.4844 46.5616 46.5616C51.4844 41.6387 54.25 34.9619 54.25 28C54.25 21.0381 51.4844 14.3613 46.5616 9.43845C41.6387 4.51562 34.9619 1.75 28 1.75C21.0381 1.75 14.3613 4.51562 9.43845 9.43845C4.51562 14.3613 1.75 21.0381 1.75 28V28Z",
    stroke: "currentColor",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 19.25L33.25 15.75H22.75L21 19.25H17.5C16.5717 19.25 15.6815 19.6187 15.0251 20.2751C14.3687 20.9315 14 21.8217 14 22.75V33.25C14 34.1783 14.3687 35.0685 15.0251 35.7249C15.6815 36.3813 16.5717 36.75 17.5 36.75H38.5C39.4283 36.75 40.3185 36.3813 40.9749 35.7249C41.6312 35.0685 42 34.1783 42 33.25V22.75C42 21.8217 41.6312 20.9315 40.9749 20.2751C40.3185 19.6187 39.4283 19.25 38.5 19.25H35Z",
    stroke: "currentColor",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.625 27.125C23.625 27.6995 23.7382 28.2684 23.958 28.7992C24.1779 29.33 24.5002 29.8123 24.9064 30.2186C25.3127 30.6248 25.795 30.9471 26.3258 31.167C26.8566 31.3868 27.4255 31.5 28 31.5C28.5745 31.5 29.1434 31.3868 29.6742 31.167C30.205 30.9471 30.6873 30.6248 31.0936 30.2186C31.4998 29.8123 31.8221 29.33 32.042 28.7992C32.2618 28.2684 32.375 27.6995 32.375 27.125C32.375 26.5505 32.2618 25.9816 32.042 25.4508C31.8221 24.92 31.4998 24.4377 31.0936 24.0314C30.6873 23.6252 30.205 23.3029 29.6742 23.083C29.1434 22.8632 28.5745 22.75 28 22.75C27.4255 22.75 26.8566 22.8632 26.3258 23.083C25.795 23.3029 25.3127 23.6252 24.9064 24.0314C24.5002 24.4377 24.1779 24.92 23.958 25.4508C23.7382 25.9816 23.625 26.5505 23.625 27.125V27.125Z",
    stroke: "currentColor",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakingPicturesCircle);
export default __webpack_public_path__ + "static/media/TakingPicturesCircle.0d8bad7e152f461dcb764fef284fa6c2.svg";
export { ForwardRef as ReactComponent };